<template>
  <BContainer ref="container_app_responsive" fluid class="real_estate_app pt-3 pb-3">
    <BContainer ref="real_estate_wrapper" class="real_estate_wrapper">
      <BRow class="justify-content-center"> 
        <BCol cols="12" md="10" :class="kebabCase(case_item.title)" class="accordion mb-0 item-gallery-effect" :ref="`case_index_${case_item.index}`" :data-index="case_item.index" :data-thumbnail="case_item.url" v-for="case_item in cases" :key="case_item.url" role="tablist">
          <b-card>
            <BRow class="ustify-content-center ">
              <BCol cols="12" sm="4" md="4">
                <div class="card-image">
                  <img width="100%" :src="getPicture(case_item.thumbnail_url)" />
                </div>
              </BCol>
              <BCol cols="12" sm="8" md="8" class="align-self-center">
                <div class="p-md-4 p-0">
                  <h3 class="case_title">{{ case_item.short_title }}</h3>
                  <h4>{{ case_item.case_title }}</h4>
                </div>
              </BCol>
              <BCol cols="12" class="mt-3" >
                <div class="p-md-4 p-0">
                  <p class="item-summary">{{ case_item.excerpt }}</p>
                  <div class="show-more-btn">
                    <b-button v-b-toggle="`${kebabCase(case_item.title)}`" variant="link">
                      Expand <IconExpand width="24" height="24" />
                    </b-button>
                  </div>
                </div>
              </BCol>
              <div class="icon">
                <img src="@/assets/box_btn.png" />
              </div>
            </BRow>

            <b-collapse :id="kebabCase(case_item.title)" class="p-3 case-hide" accordion="my-accordion" role="tabpanel">
              <div class="mt-3 text-right border-top pt-3">
                <b-button v-b-toggle="`${kebabCase(case_item.title)}`">
                <IconClose width="16" height="16" /></b-button>
              </div>
              <BRow class="mb-1 justify-content-center">
                <BCol cols="12" md="9">              
                  <div class="property-narrative pt-5" v-html="case_item.narrative"></div>
                </BCol>
              </BRow>                
            </b-collapse>
          </b-card>
        </BCol>
      </BRow>
    </BContainer>
  </BContainer>
  
</template>

<style lang="scss">

  body {
    background-color: transparent;
  }

  .real_estate_wrapper {
    max-width: 720px;
  }

  .app_title {
    font-family: var(--headings-type-writer);
    font-size: 51px;
    text-transform: uppercase;
    color: var(--app-color-black);
    letter-spacing: -2px;
  
    @media (max-width: 576px) {
      font-size: 31px;
    }
  }

  .app_description {
    font-size: 21px;
    line-height: 31px;
    color: var(--app-color-black);
    text-align: center;
  }

  .show-more-btn {
    width: 100%;
    text-align: center;

    .btn-link {
      color: #fff;
      padding: 3px 5px;
      background: var(--app-color-red);
      border-radius: 0;
      transition: transform .25s ease-in-out;
      opacity: 0.9;
    }
    
  }

  .item-summary {
    font-family: var(--headings-type-writer);
    font-size: 18px;
    line-height: 25px;
    color: #000;
    letter-spacing: -2px;
  }

  .card {
    background-color: #fff;
  }

  .real_estate_header {
    padding: 10vh 0;

    img.cover {
      width: 100%;
    }

    img.logo {
      width: 100%;
      max-width: 220px;
    }
  }

  h3.case_title {
    font-family: var(--headings-type-writer);
    color: var(--app-color-red);
    font-size: 27px;
    letter-spacing: -2px;
    font-weight: 600;

    a {
      color: #333;
    }
  }

  .full-title {
    color: var(--app-color-black);
    font-size: 41px;
    margin-bottom: 15px;

    a {
      color: #333;
    }
  }

  h4 {
    font-family: var(--headings-type-writer);
    font-size: 27px;
    color: var(--app-color-black);
  }

  .case-hide {
    font-size: 20px;

    p {
      font-family: (--app-font-family-serif);
      font-size: 21px;
      line-height: 1.2em;
      margin-bottom: 21px;
    }
  }

  .item-gallery-thumb {
    height: auto;
    background: var(--app-color-light);
    opacity: 0.5;
    transition: opacity .15s ease-in-out;
    border-radius: 100%;
    overflow: hidden;

    img {
      border-radius: 100%;
    }

    button {
      display: block;
      width: 100%;
      font-size: 17px;
      font-weight: 600;
      line-height: 1.2em;
      color: var(--app-color-red);
      outline: none;
      border: none;
    }

    &:hover,
    &.active-item {
      opacity: 1;

      button {
        color: var(--app-color);
        background-color: var(--app-color-red);
      }
    }
  }

  .item-gallery-effect {
    position: relative;
    margin: 25px 0;
    transition: opacity .1s ease-in-out;

    &.active-item {
      opacity: 1;

      .btn-link {
        transform: scale(1.3);
      }
    }


    .icon {
      position: absolute;
      bottom: 0;
      width: 75px;
      right: 0;
      color: var(--app-color);

      img {
        width: 100%;
      }
    }

    .property-value {
      position: absolute;
      top: 15px;
      right: 15px;
      height: 80px;
      padding: 10px 0;
      font-size: 27px;
      font-weight: 600;
      color: #fff;
      line-height: 1.2em;
      background: var(--app-color-red);
    }

    .card-image {
      position: relative;

      img {
        max-width: 520px;
        border-radius: 100%;
      }
    }

    .property-owner {
      font-size: 17px;
      text-align: left;
      line-height: 1.2em;
      border-bottom: solid 1px var(--app-color);

      .image-owner {
        background: var(--app-color-red);
        border-radius: 100%;
      }
    }

    .property-narrative {
      text-align: left;
      font-size: 18px;
    }

    p {
      color: var(--app-color-dark-green);
    }
  }
</style>

<script>
  import IframeResizer from '@/utils/iframe-resizer'
  import * as d3 from 'd3'
  import utils from '@/mixins/utils'
  import { kebabCase } from 'lodash'
  import find from 'lodash/find'
  import IconClose from '@/components/IconClose.vue'
  import IconExpand from '@/components/IconExpand.vue'

  export default {
    name: 'Home',
    mixins: [utils],
    components: {
      IconClose,
      IconExpand
    },
    props: {
      cases: {
        type: [Array, Object],
        default: null
      }
    },
    mounted () {
      IframeResizer.create();
    },
    data() {
      return {
        offset: 350,
        counterGallery: 1,
        currentOffset: 0,
        currentCase: {
          index: `00`
        }
      }
    },
    methods: {
      kebabCase,
      showItemGallery(index) {
        let case_index = this.$refs[`case_index_${index}`]
        this.currentOffset = case_index[0].offsetTop - (this.offset/2)
        window.scrollTo(0, this.currentOffset)
      },
      animateItems() {

        let items =  Array.from(document.querySelectorAll(`.item-gallery-effect`)).map( i => {

          let values = {
            element: i,
            start: i.offsetTop - this.offset,
            end: ((i.offsetTop + i.offsetHeight) - this.offset)
          }

          let t = values.element.dataset.thumbnail

          values.element.classList.remove(`active-item`)

          document.querySelector(`#thumbnail-${t}`).classList.remove(`active-item`)

          if(window.scrollY >= values.start && window.scrollY <= values.end) {
            values.element.classList.add(`active-item`)
            document.querySelector(`#thumbnail-${t}`).classList.add(`active-item`)
            this.counterGallery = values.element.dataset.index
            
            if(this.currentCase.index != this.counterGallery) {
              this.currentCase = find(this.cases, ["index", this.counterGallery])
              if(this.$route.params.url_celebrity != kebabCase(this.currentCase.title)) {
                this.$router.push({
                  name: 'celebrity.page',
                  params: {
                    url_celebrity: this.currentCase.url
                  }
                })
              }              
            }

            this.currentOffset = values.start            
            let tHeight = (window.innerHeight - (500 + this.$refs['table-content'].offsetHeight))
            let tPage = this.$refs['real_estate_wrapper'].offsetHeight            
            let topPercent = d3.scaleLinear().domain([0, tPage]).range([500, tHeight])
            this.$refs['table-content'].style = `top: ${topPercent(window.scrollY + 500)}px`           

          }

          return 
        })

        return items
      }
    }
  }

</script>